import eventBus from 'js/eventBus';
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwCheckbox from 'viewmodel/AwCheckboxViewModel';
import AwPanelHeader from 'viewmodel/AwPanelHeaderViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import { isEmpty } from 'lodash';

export const arrangeColumnsRenderFunction = ({ fields, formProp, viewModel }) => {
    const { subPanelContext } = viewModel;

    const columnList = subPanelContext.columnProvider.columnConfig.columns.map((item, index) => {
        const checked = !item.visible;
        const checkboxValProp = {
            fielddata: {
                propertyDisplayName: item.displayName,
                type: 'BOOLEAN',
                isRequired: 'false',
                isEditable: 'true',
                labelPosition: 'PROPERTY_LABEL_AT_RIGHT',
                labelPlacement: 'end',
                renderingHint: 'checkbox',
                uiValue: !item.visible,
                dbValue: !item.visible
            },
            value:item.visible,
            checked
        };
        checkboxValProp.onChange = (event) => {
            item.visible = !event.target.checked;
            eventBus.publish('des.arrange.columns.checkbox.selected', {});
        }
        return <AwCheckbox {...checkboxValProp} />
    });
    const actions = {
        cancel: (e) => {
            subPanelContext.dataProvider.cols.map((item, index) => {
                const cc = subPanelContext.columnProvider.columnConfig.columns.find(col => col.name === item.name);
                cc.visible = item.visible;
            });
            eventBus.publish('des.arrange.columns.close', {});
        },
        ok: (e) => {
            const dataProvider = subPanelContext.dataProvider;
            const columnProvider = subPanelContext.columnProvider;
            const columns = columnProvider.columnConfig.columns.filter(col => col.visible === true);
            dataProvider.cols.map((item) => {
                const found = columns.find(col => col.name === item.name);
                if (isEmpty(found)) {
                    item.visible = false;
                } else {
                    item.visible = true;
                }
            });
            const innerConfig = { columns };
            dataProvider.columnConfig = innerConfig;
            dataProvider.resetColumnConfigs = null;
            dataProvider.gridContextDispatcher({
                type: 'UPDATE_VALUES',
                columnConfig: dataProvider.columnConfig
            });

            eventBus.publish('des.arrange.columns.close', {});
        }
    }
    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <AwPanelHeader className='aw-layout-panelTitle sw-row'>
                <label>Columns</label>
            </AwPanelHeader>
            <AwPanel>
                <AwPanelBody>
                    {columnList}
                </AwPanelBody>
                <AwPanelFooter>
                    <div id='sw-button-group' class='sw-button-group'>
                        <AwButton id='sw-button-cancel' button-type='base' action={actions.cancel} > Cancel </AwButton>
                        <AwButton id='sw-button-ok' type='button' action={actions.ok} > Ok </AwButton>
                    </div>
                </AwPanelFooter>
            </AwPanel>
        </div>
    );
};
